package com.ervasstudio.tracoemovimento.style

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

// Em algum lugar global no seu projeto (ex: em um AppStyleSheet ou em um objeto de estilo)
// Se não tiver um AppStyleSheet, você pode colocá-lo antes do seu @Composable.

val MoveDiagonal = Keyframes {
    // 0% - Início da animação (Canto Superior Direito)
    from {
        Modifier.top(10.px).right(360.px)
    }
    // 50% - Ponto intermediário (central ou lateral)
    50.percent {
        Modifier.top(100.px).right(100.px) // Ponto para o meio
    }
    // 100% - Fim da animação (Canto Inferior Esquerdo)
    to {
        Modifier.bottom(40.px).left(150.px) // Usar bottom/left é mais complexo com top/right, melhor usar transform: translate
        // Vamos simplificar o movimento usando translate para melhor controle
        Modifier.transform {
            translate(0.percent, 0.percent) // Início (posição original)
        }
    }
}

val TeamCardStyle = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
            .borderRadius(12.px)
            .cursor(Cursor.Pointer)
    }
}

val OverlayStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .top(0.px).left(0.px).right(0.px).bottom(0.px)
            .opacity(0)
            .styleModifier {
                property("transition", "opacity 0.28s ease")
            }
    }
    hover {
        Modifier.opacity(1)
    }
}

// Melhor abordagem para o movimento diagonal da seta (usando translate para animação fluida)
val DiagonalMovement = Keyframes {
    0.percent { Modifier.transform { translate(0.px, 0.px) } }
    50.percent { Modifier.transform { translate((-100).px, 100.px) } } // Move ligeiramente para baixo/esquerda
    100.percent { Modifier.transform { translate((-300).px, 300.px) } } // Move mais para baixo/esquerda
}


// Animação de Rotação (para o 'X')
val RotateLoop = Keyframes {
    from { Modifier.transform { rotate(0.deg) } }
    to { Modifier.transform { rotate(360.deg) } }
}